module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pp-artist-grid': 1,
      'pp-artist-grid--mobile-horizontal': _vm.mobileHorizontal
    },
    style: ({
      'max-height': _vm.maxRows ? ((_vm.$root.view == 'mobile' ? 162 : 180) * _vm.maxRows) + 'px' : ''
    })
  }, [_vm._l((_vm.items), function(item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "pp-artist-grid__item",
      attrs: {
        "to": _vm.linkTo ? _vm.linkTo.replace('{id}', item.id) : ''
      }
    }, [_c('div', {
      staticClass: "pp-artist-grid__item__artwork",
      style: ({
        'background-image': item.thumbnail ? 'url(' + item.thumbnail + ')' : null
      })
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail
      }
    }), _vm._v(" "), (!item.thumbnail) ? _c('span', {
      staticClass: "pp-artist-grid__item__initials"
    }, [_vm._v("\n                " + _vm._s(_vm.useLastnamePlaceholder ?
      item.display_name.split(' ').reverse()[0].substring(0, 1) :
      item.display_name.substring(0, 1)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "pp-artist-grid__item__title"
    }, [_c('div', [_vm._v(_vm._s(item.display_name))])])])
  }), _vm._v(" "), (_vm.paginating) ? _c('loading-indicator') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da141322","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArtistGrid.vue
// module id = 142
// module chunks = 0 1